<template>
  <div class="project">
    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>

    <div class="banner">
      <div
        style="width: 1200px; height: 100%; position: relative; margin: 0 auto"
      >
        <div class="upload-btn" style="" @click="toUpload">
          <img src="../../static/server/whiteupload.png" alt="" />
          <span></span>
          上传项目
        </div>
        <h2>项目库</h2>
        <div class="banner-liner"></div>
        <p>Project Database</p>
      </div>
    </div>
    <div class="search-wrap">
      <div class="search-input">
        <input type="text" v-model="realName" placeholder="请输入关键字" />
        <button @click="search">搜索</button>
      </div>
      <div style="padding: 20px 0; background-color: #fff">
        <div class="select-wrap">
          <div class="select-title">行业：</div>
          <div class="select-content">
            <ul>
              <li
                :class="{ active: areaIndex == item.id ? true : false }"
                @click="areaFn(item.id)"
                v-for="(item, index) in areaList"
                :key="index"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="select-wrap">
          <div class="select-title">公司规模：</div>
          <div class="select-content">
            <ul>
              <li
                :class="{ active: areaIndex1 == item.id ? true : false }"
                @click="areaFn1(item.id,item.low,item.high)"
                v-for="(item, index) in areaLists"
                :key="index"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="content-body">
      <div class="content-title">
        <div style="width: 309px">项目名称</div>
        <div style="width: 250px">项目亮点</div>
        <div style="width: 152px">融资阶段</div>
        <div style="width: 145px">所属行业</div>
        <div style="width: 157px">员工规模</div>
        <div style="flex: 1">项目详情</div>
      </div>
      <ul>
        <li class="project-item" v-for="(item, index) in projectList" :key="index">
          <div style="width: 309px;text-align: center;">
            <p style="font-weight: bold; font-size: 16px; line-height: 67px">
              {{item.name}}
            </p>
            <div style="width: 309px;text-align: center;">
              <div style="width:200px;height:120px;overflow:hidden;display:inline-block">
                <img class="hover" style="width: 200px; height: 120px;display:inline-block" :src="item.projectImg" alt="" />
              </div>
            </div>
          </div>
          <div style="width: 250px">
            <p class="content-remaker">
              {{item.remark}}
            </p>
          </div>
          <div style="width: 152px; line-height: 217px">{{item.financingStage}}</div>
          <div style="width: 145px; line-height: 217px">{{item.industryName}}</div>
          <div style="width: 157px; line-height: 217px">{{item.staffScale}}</div>
          <div style="flex: 1; position: relative"><p class="btn" @click="toProjectDetail(item.id)">详情</p></div>
        </li>
      </ul>
    </div>
    <div style="width: 100%; height: 20px; clear: both"></div>
  </div>
</template>

<script>
import navigation from "@/components/common/navigation";

export default {
  name: "project",
  components: {
    navigation,
  },
  data() {
    return {
      projectList: [], //项目列表
      areaList: [{}],
      areaIndex: 0,
      areaIndex1: 0,
      areaFlag: 1,
      realName: "",
      areaLists: [
        {
          id: 0,
          name: "全部",
          low:0,
          high:null
        },
        {
          id: 1,
          name: "少于5人",
          low:0,
          high:5
        },
        {
          id: 2,
          name: "5-10人",
          low:5,
          high:10
        },
        {
          id: 3,
          name: "10-20人",
          low:5,
          high:10
        },
        {
          id: 4,
          name: "20-50人",
          low:20,
          high:50
        },
        {
          id: 5,
          name: "50-100人",
          low:50,
          high:100
        },
        {
          id: 6,
          name: "100-500人",
          low:100,
          high:500
        },
        {
          id: 7,
          name: "500人以上",
          low:500,
          high:10
        },
      ],
      low:0,
      high:null
    };
  },
  created() {
    var _this = this;
    document.onkeydown = function (e) {
      let key = window.event.keyCode;
      if (key == 13) {
        _this.search();
      }
    };
    // 列表
    this.getProjectList();
    //行业  industry
    this.$axios.get("/v1/cloud/common/industry").then(({ data }) => {
      if (data) {
        this.areaList = data;
      }
    });
  },
  mounted() {
    //滚动条从顶部开始
    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (osTop > 0) {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
  },
  methods: {
    // 获取列表
    getProjectList() {
      this.$axios
        .post("/v1/cloud/common/project-library", {
          industryId: this.areaIndex,
          name: this.realName,
          low:this.low,
          high:this.high
        })
        .then(({ data }) => {
          if (data) {
            data.forEach((item, index) => {
              if (item.remark.length > 130) {
                item.remark = item.remark.substr(0, 130) + "...";
              }
            });
            this.projectList = data;
          }
        });
    },
    toUpload() {
      this.$router.push("/projectUpload");
    },
    toProjectDetail(id) {
      // this.$router.push('/projectDetail')

      this.$router.push({
        path: "/projectDetail",
        query: {
          id,
        },
      });
    },
    areaFn(d) {
      this.areaIndex = d;
      //项目列表
      this.getProjectList();
    },
    areaFn1(d,low,high) {
      this.areaIndex1 = d;
      this.low = low
      this.high = high
      //项目列表
      this.getProjectList();
    },
    search() {
      this.getProjectList();
    },
  },
};
</script>

<style scoped lang="less">
img.hover {
  transition: all 1s
}
img.hover:hover {
  transition: all 1.5s;
  transform: scale(1.3);
}
.project {
  width: 100%;
  background-color: #f5f5f5;
  .banner {
    width: 100%;
    height: 500px;
    background: url(../../static/project/banner.png);
    background-size: 100% 100%;
    background-position: center;
    margin-bottom: 30px;
    position: relative;
    .upload-btn {
      width: 150px;
      height: 50px;
      position: absolute;
      left: 40px;
      top: 50px;
      line-height: 50px;
      border-radius: 20px;
      cursor: pointer;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background-color: #3476c1;
      border-radius: 5px;
      background-image: linear-gradient(#61aafe, #3476c1);
      text-indent: 57px;
      img {
        width: 16px;
        height: 16px;
        position: absolute;
        top: 17px;
        left: 31px;
      }
    }
    h2 {
      font-size: 65px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      line-height: 60px;
      position: absolute;
      right: 100px;
      top: 100px;
    }
    .banner-liner {
      width: 80px;
      height: 2px;
      background: #ffffff;
      position: absolute;
      top: 191px;
      right: 210px;
    }
    p {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 19px;
      position: absolute;
      top: 223px;
      right: 106px;
    }
  }
  .search-wrap {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 30px;
    .search-input {
      margin-left: 61px;
      margin-bottom: 24px;
      input {
        width: 600px;
        outline: none;
        height: 40px;
        vertical-align: middle;
        text-indent: 11px;
        border: 1px solid #dddddd;
        box-sizing: border-box;
        border-radius: 3px;
        background-color: #fff;
      }
      input::placeholder {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
      }
      button {
        width: 100px;
        height: 40px;
        background: #3476c1;
        border-radius: 0px 3px 3px 0px;
        outline: none;
        border: none;
        text-align: center;
        line-height: 40px;
        margin-left: -1px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        vertical-align: middle;
        cursor: pointer;
      }
    }
    .select-wrap {
      display: flex;
      background-color: #fff;
      box-sizing: border-box;
      .select-title {
        width: 90px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #666666;
        line-height: 30px;
        text-align: right;
      }
      .select-content {
        width: 1100px;
        ul {
          width: 100%;
          margin: 0;
          li {
            cursor: pointer;
            list-style: none;
            display: inline-block;
            width: auto;
            padding: 0 10px;
            line-height: 30px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            margin-right: 20px;
            margin-bottom: 10px;
            span {
              white-space: nowrap;
            }
          }
          li.active {
            background-color: #3476c1;
            color: #fff;
          }
        }
      }
    }
  }
  .content-body {
    width: 1200px;
    margin: 0 auto;
    padding: 20px;
    box-sizing: border-box;
    background-color: #fff;
    .content-title {
      width: 1160px;
      display: flex;
      text-align: center;
      background-color: #f5f5f5;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      border: 1px solid #e5e5e5;
    }
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      .project-item {
        display: flex;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        text-align: center;
        height: 217px;
        border: 1px solid #eeeeee;
        border-top: none;
        .content-remaker {
          width: 184px;
          margin: 50% auto 0;
          text-align: justify;
          word-wrap: break-word;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          transform: translateY(-80%);
        }
        .btn {
          width: 100px;
          height: 40px;
          color: #5fc0e4;
          border: 1px solid #5fc0e4;
          box-sizing: border-box;
          margin: 50% auto 0;
          border-radius: 3px;
          line-height: 40px;
          display: inline-block;
          vertical-align: middle;
          transform: translateY(30%);
          cursor: pointer;
        }
        .btn:hover {
          background-color: #5fc0e4;
          color: #fff;
        }
      }
    }
  }
}
</style>
